/* ============================================================
   Charity, Light a Candle (login-gated, no free text)
   Transparency counters + bar chart fill animation
   ============================================================ */
(() => {
  'use strict';

  /* ── Animated counters (intersection-triggered count-up) ── */
  const counters = document.querySelectorAll('[data-countup]');
  if (counters.length) {
    const counterIO = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        const target = parseInt(el.getAttribute('data-countup'), 10) || 0;
        const duration = 1400;
        const start = performance.now();
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        const tick = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const val = Math.round(ease(t) * target);
          el.textContent = val.toLocaleString('en-US');
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        counterIO.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach((c) => counterIO.observe(c));
  }

  /* ── Bar chart fill animation ─────────────────────────── */
  const bars = document.querySelectorAll('[data-bar]');
  if (bars.length) {
    const barIO = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        const w = el.getAttribute('data-bar') + '%';
        setTimeout(() => { el.style.width = w; }, 120);
        barIO.unobserve(el);
      });
    }, { threshold: 0.5 });
    bars.forEach((b) => barIO.observe(b));
  }

  /* ── Candle wall ──────────────────────────────────────── */
  const WALL_SIZE = 96;
  const CANDLES_KEY = 'utc_candles';
  const USER_KEY = 'utc_user';

  // Pre-existing lit candles (community history), name + date only
  const initialCandles = [
    { name: 'Maria K.',     d: 'May 14, 2026' },
    { name: 'Anonymous',    d: 'May 14, 2026' },
    { name: 'Christos P.',  d: 'May 13, 2026' },
    { name: 'Eleni T.',     d: 'May 13, 2026' },
    { name: 'Anonymous',    d: 'May 12, 2026' },
    { name: 'Yannis K.',    d: 'May 12, 2026' },
    { name: 'Sophia M.',    d: 'May 11, 2026' },
    { name: 'Anonymous',    d: 'May 11, 2026' },
    { name: 'Father Ioannis', d: 'May 10, 2026' },
    { name: 'Andreas L.',   d: 'May 10, 2026' },
    { name: 'Helena S.',    d: 'May 09, 2026' },
    { name: 'Anonymous',    d: 'May 09, 2026' },
    { name: 'Stelios D.',   d: 'May 08, 2026' },
    { name: 'Maria K.',     d: 'May 08, 2026' },
    { name: 'Anonymous',    d: 'May 07, 2026' },
    { name: 'Petros H.',    d: 'May 07, 2026' },
    { name: 'Anonymous',    d: 'May 06, 2026' },
    { name: 'Theodora P.',  d: 'May 06, 2026' },
  ];

  function getUser() {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); } catch (_) { return null; }
  }
  function loadCandles() {
    try {
      const stored = JSON.parse(localStorage.getItem(CANDLES_KEY) || '[]');
      return [...initialCandles, ...stored];
    } catch (_) { return [...initialCandles]; }
  }
  function persistCandle(entry) {
    try {
      const stored = JSON.parse(localStorage.getItem(CANDLES_KEY) || '[]');
      stored.push(entry);
      localStorage.setItem(CANDLES_KEY, JSON.stringify(stored));
    } catch (_) {}
  }

  const wall = document.getElementById('candleWall');
  const counterDisplay = document.getElementById('candleCount');
  let candles = loadCandles();

  function renderWall(justLit) {
    if (!wall) return;
    wall.innerHTML = '';
    // Newest first, column scroll, unlimited candles, ordered stack.
    const ordered = candles.slice().reverse();
    ordered.forEach((c, i) => {
      const cell = document.createElement('div');
      cell.className = 'ch-candle-cell' + (justLit && i === 0 ? ' ch-candle-cell--justlit' : '');
      cell.setAttribute('data-name', c.name);
      cell.setAttribute('data-date', c.d);
      cell.setAttribute('role', 'listitem');
      cell.setAttribute('aria-label', c.name + ', ' + c.d);
      cell.innerHTML =
        '<div class="ch-candle-glyph" aria-hidden="true">' +
          '<div class="ch-candle-flame"></div>' +
          '<div class="ch-candle-stick"></div>' +
        '</div>' +
        '<div class="ch-candle-meta">' +
          '<span class="ch-candle-meta__name">' + c.name + '</span>' +
          '<span class="ch-candle-meta__date">' + c.d + '</span>' +
        '</div>';
      wall.appendChild(cell);
    });
    if (counterDisplay) {
      const loc = (document.documentElement.getAttribute('data-lang') === 'gr') ? 'el-GR' : 'en-US';
      counterDisplay.textContent = (1247 + candles.length - initialCandles.length).toLocaleString(loc);
    }
    // Scroll the column to the top so the just-lit candle is visible.
    if (justLit) wall.scrollTop = 0;
    bindWallEvents();
  }

  /* Candle tooltip, name + date only */
  let tooltip;
  function ensureTooltip() {
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'ch-candle-tooltip';
      document.body.appendChild(tooltip);
    }
  }
  function showTooltip(cell) {
    ensureTooltip();
    const name = cell.getAttribute('data-name');
    const date = cell.getAttribute('data-date');
    if (!name) return;
    tooltip.innerHTML = name + '<span class="ch-candle-tooltip__date">' + date + '</span>';
    tooltip.classList.add('is-visible');
    const r = cell.getBoundingClientRect();
    let left = r.left + r.width / 2 - 100;
    if (left < 8) left = 8;
    if (left + 200 > window.innerWidth) left = window.innerWidth - 208;
    tooltip.style.left = left + 'px';
    tooltip.style.top = (r.top - 64) + 'px';
  }
  function hideTooltip() { if (tooltip) tooltip.classList.remove('is-visible'); }

  function bindWallEvents() {
    // Each cell now shows name + date inline, no tooltip overlay needed.
    // No empty slots anymore; new candles come via the #lightCandleBtn.
  }

  /* Try to light, if not signed in, show login prompt */
  const loginPrompt = document.getElementById('loginPrompt');
  const loginPromptClose = document.getElementById('loginPromptClose');
  const lightBtn = document.getElementById('lightCandleBtn');

  function showLoginPrompt() {
    if (loginPrompt) loginPrompt.classList.add('is-open');
  }
  function closeLoginPrompt() {
    if (loginPrompt) loginPrompt.classList.remove('is-open');
  }
  if (loginPromptClose) loginPromptClose.addEventListener('click', closeLoginPrompt);
  if (loginPrompt) loginPrompt.addEventListener('click', (e) => { if (e.target === loginPrompt) closeLoginPrompt(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLoginPrompt(); });

  function tryLightCandle() {
    const user = getUser();
    if (!user) {
      showLoginPrompt();
      return;
    }
    // Signed in, light it directly
    const today = new Date();
    const loc = (document.documentElement.getAttribute('data-lang') === 'gr') ? 'el-GR' : 'en-US';
    const dateStr = today.toLocaleDateString(loc, { month: 'short', day: '2-digit', year: 'numeric' });
    const entry = { name: (user.name && user.name.split(' ')[0]) || 'Friend', d: dateStr };
    candles.push(entry);
    persistCandle(entry);
    const newIndex = candles.length - 1;
    renderWall(newIndex);
    showToast(document.documentElement.getAttribute('data-lang') === 'gr'
      ? 'Το κερί σου καίει. Ευχαριστούμε.'
      : 'Your candle is burning. Thank you.');
  }
  if (lightBtn) lightBtn.addEventListener('click', tryLightCandle);

  renderWall();

  /* ── Toast helper ─────────────────────────────────────── */
  function showToast(msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(showToast._tm);
    showToast._tm = setTimeout(() => t.classList.remove('show'), 3200);
  }

})();
